import { CommunityAnnouncements } from '@platform/client';
import { Input, Modal } from '@platform/components';
import { useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';

interface CreateCommunityAnnouncementModalProps {
  isOpen: boolean;
  onClose: () => void;
  resetPagination: () => void;
  limit: number;
}

export const CreateCommunityAnnouncementModal = (props: CreateCommunityAnnouncementModalProps) => {
  const { isOpen, onClose, resetPagination, limit } = props;

  const [title, setTitle] = useState('');
  const [cta, setCta] = useState('');
  const [description, setDescription] = useState('');
  const [link, setLink] = useState('');

  const queryClient = useQueryClient();

  const submitCommunityAnnouncement = CommunityAnnouncements.useCreateCommunityAnnouncement({
    mutation: {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: [
            ...CommunityAnnouncements.getGetCommunityAnnouncementsQueryKey({ page: 0, limit }),
          ],
        });
        resetPagination();
      },
    },
  });

  const createCommunityAnnouncement = async () => {
    submitCommunityAnnouncement.mutate({
      data: {
        title,
        description,
        callToAction: cta,
        link,
      },
    });

    closeModal();
  };

  const closeModal = () => {
    onClose();
    setTitle('');
    setDescription('');
    setCta('');
    setLink('');
  };

  return (
    <Modal
      variant='dialog'
      title='Create Community Announcement'
      isOpen={isOpen}
      headerDivision='divider'
      ignoreExtraPadding={true}
      onClose={closeModal}
      primaryCTA={{
        text: 'Create Community Announcement',
        callback: createCommunityAnnouncement,
      }}
      secondaryCTA={{
        text: 'Cancel',
        callback: closeModal,
      }}
    >
      <div className='md:w-[460px]'>
        <div className='flex flex-col gap-4 w-full'>
          <Input
            label='Title'
            type='inline'
            value={title}
            onChange={(e) => setTitle(e.target.value)}
          />
          <Input
            label='Call to Action'
            type='inline'
            value={cta}
            onChange={(e) => setCta(e.target.value)}
          />
          <Input
            label='Link'
            type='inline'
            value={link}
            onChange={(e) => setLink(e.target.value)}
          />
          <Input
            label='Description'
            type='multiline'
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          />
        </div>
      </div>
    </Modal>
  );
};
